import React, {useEffect, useState} from 'react';
import {
  Route,
  Routes,
  matchPath,
  useLocation,
  Navigate,
} from 'react-router-dom';
import ConnectPlatformsWizard from '@/components/brand-safety/connect-platform-wizard/ConnectPlatformsWizard';
import OnboardingView from '@/views/onboarding';
import useUserQuery from '@/hooks/queries/use-user-query';
import EmberIframe from '@/components/ember-iframe';
import Menu from '@/components/menu';
import GigsCollectionPage from '@/views/gigs-collection';
import CallbackRoute from '@/routes/common/CallbackRoute';
import styles from './MainRoutes.module.scss';
import Banner from '@/components/banner';
import Delta from '@/utils/wrappers/Delta';
import GigsFiltersPopup from '@/components/filters-popup';
import {useSaveUtmAttributionToSessionStorage} from '@/utils/utmAttributionTracker';
import useReonboarding from '@/hooks/use-reonboarding';
import PoppaysLoader from '@/components/poppays-loader';
import GigDeliverablesGate from '@/views/gig-deliverables/GigDeliverablesGate';

const STANDALONE_ROUTES = ['/onboarding/*'];

function MainRoutes() {
  const location = useLocation();
  const [emberModalIsOpen, setEmberModalIsOpen] = useState(false);
  const {user: userData, isLoading: isLoadingUser} = useUserQuery({});
  const {shouldRedirectToOnboarding, isLoading: isLoadingReonboarding} =
    useReonboarding();

  useSaveUtmAttributionToSessionStorage();

  useEffect(() => {
    const removeModalListener = EmberIframe.listen(
      'modal',
      setEmberModalIsOpen
    );
    return removeModalListener;
  }, []);

  useEffect(() => {
    if (userData?.id) {
      Delta.setCreatorId(userData.id);
    }
  }, [userData]);

  const showLayout = !STANDALONE_ROUTES.some((route: string) =>
    matchPath(route, location.pathname)
  );

  if (isLoadingReonboarding || isLoadingUser) {
    return <PoppaysLoader />;
  }

  if (shouldRedirectToOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <>
      {showLayout && (
        <Banner
          emberModalIsOpen={emberModalIsOpen}
          userData={userData}
          isLoadingUser={isLoadingUser}
        />
      )}
      <div className={styles.appWrapper}>
        {showLayout && <Menu emberModalIsOpen={emberModalIsOpen} />}
        <Routes>
          <Route path="/v2">
            <Route index element={<GigsCollectionPage />} />
            <Route path="/v2/callback" element={<CallbackRoute />} />
            {/* Future v2 routes will go here */}
            {/* <Route path="campaigns/:campaignId" element={<CampaignPage />} /> */}
            {/* <Route path="gigs/your-gigs" element={<YourGigsPage />} /> */}
          </Route>

          <Route index element={<GigsCollectionPage />} />
          <Route path="/callback" element={<CallbackRoute />} />
          <Route path="/gigs/:gigId/*" element={<GigDeliverablesGate />} />
          <Route path="*" element={<EmberIframe />} />
          <Route
            path="/connect-platforms/*"
            element={<ConnectPlatformsWizard />}
          />
          <Route path="/onboarding/*" element={<OnboardingView />} />
          {/* <Route path="/new-page" element={<NewPage />} /> */}
        </Routes>
      </div>

      {/* TODO: Move GigsFiltersPopup back to GigsCollectionPage once the transition to React is complete */}
      <GigsFiltersPopup />
    </>
  );
}

export default MainRoutes;
